import Icon from 'presentations/views/components/atoms/Icon';
import Avatar, {
  AvatarBadge,
} from 'presentations/views/components/atoms/Avatar';
import { ResponseStatus } from 'domains/models/event/responseStatus';
import { primary, white, whiteFix } from 'presentations/views/styles/color';
import styled from '@emotion/styled';
import { useMemo } from 'react';

interface Props {
  name: string;
  profileImage: string | null;
  color?: string | null;
  responseStatus: ResponseStatus;
}

export default function Component(props: Props) {
  const name = useMemo(() => {
    switch (props.responseStatus) {
      case ResponseStatus.Accepted:
        return 'check-solid';
      case ResponseStatus.Declined:
        return 'close';
      case ResponseStatus.Tentative:
        return 'help-solid';
      case ResponseStatus.NeedsAction:
      case ResponseStatus.None:
      default:
        break;
    }
    return null;
  }, [props.responseStatus]);

  return (
    <AvatarBadge
      badgeContent={
        name ? <CheckIcon name={name} backgroundColor={props.color} /> : null
      }
    >
      <AtendeeAvatar src={props.profileImage}>
        {props.name.substring(0, 1)}
      </AtendeeAvatar>
    </AvatarBadge>
  );
}

const AtendeeAvatar = styled(Avatar)`
  width: 36px;
  height: 36px;
`;

const CheckIcon = styled(Icon)<{ backgroundColor?: string | null }>`
  color: ${(props) => props.backgroundColor || whiteFix};
  background-color: ${primary};
  padding: 1px;
  border-radius: 50%;
  width: 16px !important;
  height: 16px !important;
`;
